import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';

const Forbidden: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Access denied
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You don’t have permission to view this page.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Forbidden;
